import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store/store";
import { Auth0Provider } from "@auth0/auth0-react";
import { ToastContainer } from "react-toastify";
import "./index.css";

ReactDOM.render(
	<Provider store={store}>
		<>
			<Auth0Provider
				domain={process.env.REACT_APP_AUTH0_DOMAIN}
				clientId={process.env.REACT_APP_AUTH0_CLIENTID}
				redirectUri={process.env.REACT_APP_LOGIN_REDIRECT}
				audience={process.env.REACT_APP_AUTH0_AUDIENCE}
				useRefreshTokens
				cacheLocation="localstorage"
			>
				<App />
			</Auth0Provider>
			<ToastContainer autoClose={3000} hideProgressBar />
		</>
	</Provider>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
